export { ContentPage as default, getServerSideProps } from 'views/contentful/ContentPage'
